var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-service-item',{attrs:{"openItem":false,"fieldsFrom":_vm.fields,"setLink":_vm.setLink,"cardLink":_vm.cardLink,"params":_vm.params},on:{"input":function($event){return _vm.$emit('input', _vm.item)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }